
import { RouteComponentProps } from "react-router-dom";
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';
import { fomatParentPath } from "../../utils";
import { MainProps } from '../../components/main/types'

@inject('mainStore')
@observer
class RouteLayoutRedirect extends Component<MainProps & RouteComponentProps>{
  render() {
    const parentPath: string = fomatParentPath(this.props);
    let { redirectRoutesData } = this.props.mainStore!;
    return (
      <>
        {redirectRoutesData && redirectRoutesData.map((path: any, index: number) => {
          return (
            <Route weId={`${this.props.weId || ''}_848m1t`} key={index} path={`${path.from}`} exact>
              <Redirect weId={`_i79t2v`} to={path.to} />
            </Route>
          )
        })}
      </>
    )
  }
}

export default withRouter(RouteLayoutRedirect);